import React, { FC, useCallback } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Row, Typography } from 'components';
import { ADMIN_ROUTES } from 'constants/routes';
import { useNavigate } from 'react-router-dom';
import { AllEntityTypes, TypeOfEntityType } from 'models/ComunicationHub';

interface IEntityDrawer {
  onExpand: () => void;
  drawerState: boolean;
  entity: string;
  data?: Record<string, any[]>;
}

export const EntityDrawer: FC<IEntityDrawer> = React.memo((props) => {
  const { onExpand, drawerState, entity, data } = props;
  const navigate = useNavigate();
  const onRouteChange = useCallback(
    (entityName: TypeOfEntityType, id: string) => {
      switch (entityName) {
        case 'SUPPLIER':
          navigate(`${ADMIN_ROUTES.suppliers.view}/${id}/general`);
          return;
        case 'BRAND':
          navigate(`${ADMIN_ROUTES.brand.view}/${id}/management`);
          return;
        case 'CLIENT':
          navigate(`${ADMIN_ROUTES.client}/${id}/general`);
          return;
        case 'LEAD':
          navigate(`${ADMIN_ROUTES.leads.view}/${id}/general`);
          return;
        case 'DEAL':
          navigate(`${ADMIN_ROUTES.deals.view}/${id}/purchase-request`);
          return;
        default:
          return;
      }
    },
    [navigate]
  );
  return (
    <Drawer
      closeIcon={null}
      placement="left"
      width={471}
      open={drawerState}
      onClose={() => onExpand()}
      styles={{
        header: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      }}
      title={'References'}
    >
      <div style={{ position: 'absolute', right: 16, top: 16 }}>
        <Button icon={<CloseOutlined />} onClick={() => onExpand()} type="text" />
      </div>
      <Row gutter={[0, 16]}>
        {data &&
          Object.entries(data)
            .filter(([type]) => type !== entity)
            .map(([type, entities]) => (
              <Col span={24} key={type}>
                <Row key={type} gutter={[0, 8]}>
                  <Col span={24}>
                    <Typography.Text className={'font-size-16 font-weight-500'}>
                      {`${AllEntityTypes[type]?.label}s`}
                    </Typography.Text>
                  </Col>
                  <Col span={24}>
                    <Row gutter={[0, 16]}>
                      {entities.map((entity) => (
                        <Col key={entity.id} span={24}>
                          <Typography.Text
                            type={'secondary'}
                            underline
                            style={{ cursor: 'pointer' }}
                            onClick={() => onRouteChange(type as TypeOfEntityType, entity.id)}
                          >
                            {entity.name || entity.uuid}
                          </Typography.Text>
                        </Col>
                      ))}
                    </Row>
                  </Col>
                </Row>
              </Col>
            ))}
      </Row>
    </Drawer>
  );
});
